import React from "react";
import { StyleSheet, Text, View } from "react-native";

import BaseProfileCard from "@/screens/Explore/Components/ProfileCard/BaseProfileCard";
import CommonInterests from "@/screens/Explore/Components/ProfileCard/Components/CommonInterests";
import { themes } from "@/Components/Styling/themeConfigs";
import { UserRecommendedItem } from "@/schemas/user/explore";
import { Spacings } from "@/styling/spacings";
import { ProfileCardState } from "@/utils/explore";

type Props = {
  profile: UserRecommendedItem;
  itemWidth: number;
  itemHeight: number;
  displayHighlights?: boolean;
  cardState?: ProfileCardState;
  onNonNormalStateCardClick?: () => void;
};

function SmallProfileCard({
  profile,
  itemWidth,
  itemHeight,
  displayHighlights = true,
  cardState = "normal",
  onNonNormalStateCardClick = (): void => {},
}: Props): React.JSX.Element {
  return (
    <BaseProfileCard
      profile={profile}
      itemWidth={itemWidth}
      itemHeight={itemHeight}
      displayHighlights={displayHighlights}
      isLargeCard={false}
      cardState={cardState}
      onNonNormalStateCardClick={onNonNormalStateCardClick}
    >
      <View style={styles.bottomContainerOverlay}>
        {/* username */}
        <Text
          style={styles.usernameText}
          numberOfLines={1}
          ellipsizeMode="tail"
        >
          @{profile.username}
        </Text>
      </View>

      {/* common interests (styles handled by the component) */}
      {profile.commonInterests && (
        <CommonInterests
          interests={profile.commonInterests}
          isLargeCard={false}
        />
      )}
    </BaseProfileCard>
  );
}

const currentTheme = themes.morning;

const styles = StyleSheet.create({
  bottomContainerOverlay: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    paddingVertical: Spacings.s1,
    paddingHorizontal: Spacings.s2,
  },
  usernameText: {
    color: "#fff",
    fontSize: currentTheme.typography.h3.size.mobile + 3,
    textAlign: "center",
  },
});

export default SmallProfileCard;
